export enum EUserRowState {
    NOTSTARTED = 'notstarted', // scheduled
    STARTED = 'started',  // InProgress
    COMPLETED = 'completed',
    PAUSED = 'paused',
}
